import { request } from '@/shared/api/request'
/**
 * Загружает ежедневный отчет в формате XLS для договоров на основе указанных параметров.
 *
 * @param {string} iinBin - Идентификатор ИИН или БИН, связанный с запросом.
 * @param {boolean} isEmployer - Указывает, делается ли запрос от имени работодателя.
 * @param {string} deptCode - Код отдела, для которого запрашивается отчет.
 * @param {string|number} day - День формата dd.MM.yyyy
 * @returns {Promise} Promise, разрешающийся в ответ сервера, содержащий файл отчета в формате blob.
 */
export const downloadDayXsl = (iinBin, isEmployer, deptCode, day) => {
	return request({
		url: 'contract/downloadDay',
		method: 'GET',
		responseType: 'blob',
		params: {
			iinBin,
			isEmployer,
			deptCode,
			day,
		},
	})
}
